import React from 'react'
import { FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core/index'
import boxNoSize from '../../../../assets/icons/box-nosize.png'
import boxXS from '../../../../assets/icons/box-xs.png'
import boxS from '../../../../assets/icons/box-s.png'
import boxM from '../../../../assets/icons/box-m.png'
import boxL from '../../../../assets/icons/box-l.png'
import boxXL from '../../../../assets/icons/box-xl.png'
import { strings } from '../../../../localization/strings'
import { getLockerSizesByOrderId } from '../../../../helpers/restHelpers'
import Loader from '../../../loaders/dots_loader/index'

class DoorSizeSelectorComponent extends React.Component {
    state = { sizeSelected: null, sizes: [], loading: true, error: null }

    componentDidMount() {
        this.setState({ sizes: [], loading: true, error: null })
        getLockerSizesByOrderId(this.props.orderId)
            .then(sizes => {
                if (!sizes || !sizes.length) {
                    window.showDialog({message: strings.doorSizeSelector_noDoorSizeAvailable,},()=>{
                        this.setState({loading: false })
                        this.props.handleSizeSelect(null)
                    })
                } else {
                    const size = sizes.find((x) => x.id === this.props.doorSizeId)
                    const sizeId = size?size.id:null;
                    const sizeSelected = size?size.name:null;
                    this.setState({ sizes, sizeSelected,loading: false })
                    this.handleSizeSelect(sizeId)                    
                }
            })
            .catch((error) => {
                this.handleSizeSelect()
                window.showDialog(error)
            })
    }

    selectedSize = (lockerDoor) => {
        const imgStyle = { width: '100%', maxWidth: 320 }
        switch (lockerDoor) {
            case 'XS':
                return <img alt="none" src={boxXS} style={imgStyle} />
            case 'S':
                return <img alt="none" src={boxS} style={imgStyle} />
            case 'M':
                return <img alt="none" src={boxM} style={imgStyle} />
            case 'L':
                return <img alt="none" src={boxL} style={imgStyle} />
            case 'XL':
                return <img alt="none" src={boxXL} style={imgStyle} />
            default:
                return <img alt="none" src={boxNoSize} style={imgStyle} />
        }
    }

    handleSizeSelect = (sizeId) => {
        let size =  this.state.sizes.find((x) => x.name === sizeId);
        if (size) this.setState({ sizeSelected: size.name })
        this.props.handleSizeSelect(size)
    }

    render() {
        const legendStyle = {
            whiteSpace: 'pre-line',
            fontWeight: 'bold',
            fontSize: '0.7em',
            margin: '0.2em auto',
        }

        return <>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ alignSelf: 'center' }}>
                    {this.selectedSize(this.state.sizeSelected)}
                </div>
                <div style={{ margin: '8px', alignSelf: 'center' }}>
                    <RadioGroup
                        aria-label="Gender"
                        name="gender1"
                        value={this.state.sizeSelected}
                        onChange={e=>this.handleSizeSelect(e.target.value)}
                    >
                        {!this.state.sizes.length ? (
                            <Loader />
                        ) : (
                            this.state.sizes.map((size) => (
                                <FormControlLabel
                                    key={size.name}
                                    value={size.name}
                                    control={<Radio />}
                                    label={size.name}
                                />
                            ))
                        )}
                    </RadioGroup>
                </div>

            </div>
            <Typography color="inherit" style={legendStyle}>
                {strings.doorSizeSelector_minimumSize}
            </Typography>
        </>
    }
}

export default DoorSizeSelectorComponent
